import produce from "immer";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_ROOMS_STATE,
  FETCH_ROOMS_LIST_PROGRESS,
  FETCH_ROOMS_LIST_SUCCESS,
  FETCH_ROOMS_LIST_FAILED,
} from "./roomActions";
import { initialRoomState } from "./defaultState";
import { IRoomState } from "./room.types";

export const roomReducer = (
  state: IRoomState = initialRoomState,
  action: any
): IRoomState => {
  switch (action.type) {
    case FETCH_ROOMS_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
      });
    }
    case FETCH_ROOMS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
      });
    }
    case FETCH_ROOMS_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = "Failed to fetch rooms";
      });
    }
    case CLEAR_ROOMS_STATE: {
      return initialRoomState;
    }
    default:
      return state;
  }
};
